/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { Job } from '../model/job';
// @ts-ignore
import { ResponseMessage } from '../model/responseMessage';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    RecipientsServiceInterface
} from './recipients.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class RecipientsService extends BaseService implements RecipientsServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Move job to archive if the user is owner or a recipient
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdMovetoarchivePut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdMovetoarchivePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/movetoarchive`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move job to inbox if the user is owner or a recipient
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdMovetoinboxPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdMovetoinboxPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/movetoinbox`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add a new recipient to a job with multiple recipients.  **Prerequisites:** - Job status must be DRAFT - Job type must be ME_OTHERS - Must call PUT /jobs/{id}/actions/startrequestsignature first to prepare the job  **Workflow Context:** This endpoint is step 4 in the ME_OTHERS workflow: 1. Create job: POST /jobs 2. Add documents: POST /jobs/{id}/documents 3. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 4. **Add recipients: POST /jobs/{id}/recipients** (this endpoint) 5. Optionally update recipients: PUT /recipients/{id} 6. Add signature fields and finish  **Default Behavior:** - Role is automatically set to SIGNER during creation (role parameter is ignored) - workflow_effect is automatically set to REQUIRED during creation - Use PUT /recipients/{id} to change role to VIEWER or COPY after creation - Use PUT /recipients/{id} to change workflow_effect to OPTIONAL after creation  **Recipient Roles:** - SIGNER: Can sign documents (default) - VIEWER: Can view documents but not sign - COPY: Receives copy of completed documents  **Workflow Effects:** - REQUIRED: Recipient must complete their action for workflow to proceed (default) - OPTIONAL: Workflow can proceed without this recipient\&#39;s action  **Validation:** - Name is required and cannot be empty - Email is required and must be valid - Email must be unique within the job (no duplicate recipients) - Citizen ID must be exactly 11 digits if provided 
     * @param accessToken System access token
     * @param id Job ID
     * @param name Recipient full name
     * @param email Recipient email
     * @param citizenId Citizen ID (must be exactly 11 digits)
     * @param role Recipient role. signer, viewer, copy
     * @param workflowEffect Recipient worklow effect. required, optional
     * @param orderno Recipient order no. If not given, the default is 1
     * @param phoneNumber Recipient phone number (for SMS verification)
     * @param smsCountryCode Recipient phone number country code (for SMS verification)
     * @param signMethod Explicit signing method. One of qes (qualified e-signature), bio (biometric), initials. If omitted, signing falls back to widget inference (legacy).
     * @param canCustomizeSignBox AN-1801: when true, this QES signer places/customizes their own single signature box during signing (the sender may not place it). Accepted only for role SIGNER with sign_method qes; otherwise 400 (302). Sent as boolean true/false.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling jobsIdRecipientsPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (email !== undefined && email !== null) {
            localVarFormParams = localVarFormParams.append('email', <any>email) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizen_id', <any>citizenId) as any || localVarFormParams;
        }
        if (role !== undefined && role !== null) {
            localVarFormParams = localVarFormParams.append('role', <any>role) as any || localVarFormParams;
        }
        if (workflowEffect !== undefined && workflowEffect !== null) {
            localVarFormParams = localVarFormParams.append('workflow_effect', <any>workflowEffect) as any || localVarFormParams;
        }
        if (orderno !== undefined && orderno !== null) {
            localVarFormParams = localVarFormParams.append('orderno', <any>orderno) as any || localVarFormParams;
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            localVarFormParams = localVarFormParams.append('phone_number', <any>phoneNumber) as any || localVarFormParams;
        }
        if (smsCountryCode !== undefined && smsCountryCode !== null) {
            localVarFormParams = localVarFormParams.append('sms_country_code', <any>smsCountryCode) as any || localVarFormParams;
        }
        if (signMethod !== undefined && signMethod !== null) {
            localVarFormParams = localVarFormParams.append('sign_method', <any>signMethod) as any || localVarFormParams;
        }
        if (canCustomizeSignBox !== undefined && canCustomizeSignBox !== null) {
            localVarFormParams = localVarFormParams.append('can_customize_sign_box', <any>canCustomizeSignBox) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recipients`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Configure the signing workflow order for recipients.  **Workflow Context:** This endpoint is used after adding multiple recipients to define their signing sequence: 1. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 2. Add recipients: POST /jobs/{id}/recipients (multiple times) 3. **Set recipient order: PUT /jobs/{id}/recipients** (this endpoint) 4. Add fields and finish  **Recipient Order Format:** - Sequential steps are separated by \&quot;|\&quot; (pipe) - Parallel recipients (same step) are separated by \&quot;,\&quot; (comma) - Example: \&quot;123,456|789|101,102,103\&quot;   - Step 1: Recipients 123 and 456 sign in parallel   - Step 2: Recipient 789 signs after step 1 completes   - Step 3: Recipients 101, 102, and 103 sign in parallel after step 2  **Prerequisites:** - Job must be in DRAFT status - All recipient IDs in the order string must exist and belong to the job - User must be the job owner  **Workflow Effects:** - Recipients marked as REQUIRED must complete their action before the workflow proceeds to the next step - Recipients marked as OPTIONAL can be skipped without blocking the workflow - Parallel recipients in the same step can sign in any order  **Common Use Cases:** - Define approval chain: Manager → Director → CEO - Set up parallel signing: Multiple team members sign simultaneously - Create hybrid workflows: Parallel approvals followed by final sequential signature 
     * @param accessToken System access token
     * @param id Job ID
     * @param recipientOrder Recipient order with list of recipient IDs. Sequence is separated by \\\&quot;|\\\&quot; and parallel recipients are separated with \\\&quot;,\\\&quot;. i.e: 4432,334|556,566,998|432|1123 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdRecipientsPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdRecipientsPut.');
        }
        if (recipientOrder === null || recipientOrder === undefined) {
            throw new Error('Required parameter recipientOrder was null or undefined when calling jobsIdRecipientsPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (recipientOrder !== undefined && recipientOrder !== null) {
            localVarFormParams = localVarFormParams.append('recipientOrder', <any>recipientOrder) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recipients`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get address book for the user
     * @param accessToken Access Token
     * @param lastSignedMonths Filter recipients by last signed date (e.g., 6 for last 6 months)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsAddressbookGet(accessToken: string, lastSignedMonths?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsAddressbookGet(accessToken: string, lastSignedMonths?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsAddressbookGet(accessToken: string, lastSignedMonths?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsAddressbookGet(accessToken: string, lastSignedMonths?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsAddressbookGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastSignedMonths, 'last_signed_months');

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/addressbook`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a recipient from a job.  **Workflow Context:** This endpoint allows removing recipients from a job during the preparation phase: 1. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 2. Add recipients: POST /jobs/{id}/recipients 3. **Remove unwanted recipient: DELETE /recipients/{id}** (this endpoint) 4. Continue with other recipients and finish  **Prerequisites:** - Recipient must exist - Job must be in DRAFT status (recipients can only be removed before finishing) - User must be the job owner  **Important Notes:** - You cannot delete the last recipient from a job - The requesting user (job owner) is automatically added as the first recipient when calling startrequestsignature - Once the job is finished (PUT /jobs/{id}/actions/finish), recipients cannot be removed  **Common Use Cases:** - Remove incorrectly added recipients - Simplify recipient list before finishing the job - Replace a recipient (delete old one, add new one) 
     * @param accessToken System access token
     * @param id id of the recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdDelete(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an existing recipient\&#39;s information, role, or workflow effect.  **Workflow Context:** This endpoint is used after adding a recipient to modify their properties: 1. Add recipient: POST /jobs/{id}/recipients (creates with default SIGNER/REQUIRED) 2. **Update recipient: PUT /recipients/{id}** (this endpoint - change role/workflow_effect)  **What can be updated:** - Basic information: name, email, citizen_id, phone_number, sms_country_code - Role: Change between SIGNER, VIEWER, or COPY - Workflow effect: Change between REQUIRED or OPTIONAL  **Recipient Roles:** - SIGNER: Can sign documents (default when created) - VIEWER: Can view documents but not sign - COPY: Receives copy of completed documents  **Workflow Effects:** - REQUIRED: Recipient must complete their action for workflow to proceed (default when created) - OPTIONAL: Workflow can proceed without this recipient\&#39;s action  **Prerequisites:** - Recipient must exist - Job must be in DRAFT status - User must be the job owner  **Common Use Cases:** - Change a recipient from SIGNER to VIEWER if they only need to review - Change workflow_effect to OPTIONAL for recipients whose action is not mandatory - Update contact information (email, phone) before sending notifications 
     * @param accessToken System access token
     * @param id id of the recipient
     * @param name Recipient full name
     * @param email Recipient email
     * @param citizenId Citizen ID
     * @param role Recipient role. signer, viewer, copy
     * @param workflowEffect Recipient workflow effect. required, optional
     * @param phoneNumber Recipient phone number
     * @param smsCountryCode Recipient phone number country code
     * @param signMethod Explicit signing method. One of qes (qualified e-signature), bio (biometric), initials. If omitted, the existing value is left unchanged.
     * @param canCustomizeSignBox AN-1801: when true, this QES signer places/customizes their own single signature box during signing (the sender may not place it). Accepted only for role SIGNER with sign_method qes; otherwise 400 (302). Sent as boolean true/false.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdPut.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling recipientsIdPut.');
        }
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling recipientsIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (email !== undefined && email !== null) {
            localVarFormParams = localVarFormParams.append('email', <any>email) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizen_id', <any>citizenId) as any || localVarFormParams;
        }
        if (role !== undefined && role !== null) {
            localVarFormParams = localVarFormParams.append('role', <any>role) as any || localVarFormParams;
        }
        if (workflowEffect !== undefined && workflowEffect !== null) {
            localVarFormParams = localVarFormParams.append('workflow_effect', <any>workflowEffect) as any || localVarFormParams;
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            localVarFormParams = localVarFormParams.append('phone_number', <any>phoneNumber) as any || localVarFormParams;
        }
        if (smsCountryCode !== undefined && smsCountryCode !== null) {
            localVarFormParams = localVarFormParams.append('sms_country_code', <any>smsCountryCode) as any || localVarFormParams;
        }
        if (signMethod !== undefined && signMethod !== null) {
            localVarFormParams = localVarFormParams.append('sign_method', <any>signMethod) as any || localVarFormParams;
        }
        if (canCustomizeSignBox !== undefined && canCustomizeSignBox !== null) {
            localVarFormParams = localVarFormParams.append('can_customize_sign_box', <any>canCustomizeSignBox) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resend the request to recipient
     * @param accessToken System access token
     * @param id recipient ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdResendrequestPut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdResendrequestPut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdResendrequestPut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdResendrequestPut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdResendrequestPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdResendrequestPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/resendrequest`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resend the sms verification code
     * @param accessToken System access token
     * @param id recipient ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdResendsmsPut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdResendsmsPut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdResendsmsPut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdResendsmsPut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdResendsmsPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdResendsmsPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/resendsms`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update shared signing values of recipients.
     * @param accessToken Access Token
     * @param recipientJson JSON data for recipients and fields
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsSharedsigningPut(accessToken: string, recipientJson: object, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsSharedsigningPut(accessToken: string, recipientJson: object, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsSharedsigningPut(accessToken: string, recipientJson: object, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsSharedsigningPut(accessToken: string, recipientJson: object, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsSharedsigningPut.');
        }
        if (recipientJson === null || recipientJson === undefined) {
            throw new Error('Required parameter recipientJson was null or undefined when calling recipientsSharedsigningPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/sharedsigning`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: recipientJson,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
